/// <reference path="../ObjectDataBuilder.ts" />

namespace SPA
{
	export namespace Realtor
	{

		export class ObjectBuilder
			extends SPA.Realtor.ObjectDataBuilder<Wollmilch.Realtor.Object>
		{

			private	m_Navigation?: Navigation;

			public constructor( data: Wollmilch.Realtor.Object )
			{
				super( data );
			}

			public rebuild( root: ui.base.BaseHTMLElement|JQuery<HTMLElement>, navigation: Navigation ): ObjectBuilder
			{
				this.m_Navigation	= navigation;

				// Chapter2 - thanks no left navigation
				this.m_Navigation = undefined;

				const basicBox = new ui.Box.Box();

				basicBox.clearTitle();
				basicBox.addTitle( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.SHORT.' + this.m_Data.Type ) + ': ' + this.m_Data.ObjectNumber );
				basicBox.rebuild( root.empty() );

				const flex = ui.$$.div().addClass( 'flex-container' );
				const row1 = ui.$$.div().addClass( 'flex-row' ).appendTo( flex );

				this.buildAddressInfo( this.m_Data.Address, ui.$$.div().addClass( 'col-sm-12 col-md-6' ).appendTo( row1 ), false );
				this.buildObjectOwnerInfo( this.m_Data.Owner, ui.$$.div().addClass( 'col-sm-12 col-md-6' ).appendTo( row1 ) );

				// Chapter2: we have no use for this here
				new SPA.Navigation.BreadCrumb( this.m_Data.ObjectNumber ).rebuild( basicBox );

				const html =
					'<form class="c2">' +
						'<div class="container col-sm-5">' +
						'</div>' +
						'<div class="row">' +
						'<div class="col-sm-5">' +
							'<fieldset class="form-horizontal">' +
								'<legend>Technische Angaben</legend>' +
								'<div class="form-group">' +
									'<label class="control-label col-sm-3">Status</label>' +
									'<div class="col-sm-9">' +
										'<input class="form-control" type="text" name="object.expose.housekind" value="Aktiv" />' +
									'</div>' +
								'</div>' +
								'<div class="form-group">' +
									'<label class="control-label col-sm-3">Betreuer</label>' +
									'<div class="col-sm-9">' +
										'<input class="form-control" type="text" name="object.expose.housetype" value="Zey, Frank (Hr. Zey)" />' +
									'</div>' +
								'</div>' +
								'<div class="form-group">' +
									'<label class="control-label col-sm-3">Auftragsart</label>' +
									'<div class="col-sm-9">' +
										'<input class="form-control" type="text" name="object.expose.usage" value="Verkauf" />' +
									'</div>' +
								'</div>' +
								'<div class="form-group">' +
									'<label class="control-label col-sm-3">Auftrag bis</label>' +
									'<div class="col-sm-9">' +
										'<input class="form-control" type="date" name="object.expose.marketing" value="10.06.2020" />' +
									'</div>' +
								'</div>' +
								'<div class="form-group">' +
									'<label class="control-label col-sm-3">Verkauft am</label>' +
									'<div class="col-sm-9">' +
										'<input class="form-control" type="date" name="object.expose.price" value="" />' +
									'</div>' +
								'</div>' +
							'</fieldset>' +
							'<fieldset class="col-sm-5 col-sm-offset-1 form-horizontal">' +
								'<legend>Geograpische Angaben</legend>' +
								'<div class="form-group">' +
									'<label class="control-label col-sm-3">Zimmer</label>' +
									'<div class="col-sm-9">' +
									'<input class="form-control" type="text" name="object.expose.rooms" value="6" />' +
									'</div>' +
								'</div>' +
								'<div class="form-group">' +
									'<label class="control-label col-sm-3">Badezimmer</label>' +
									'<div class="col-sm-2">' +
									'<input class="form-control" type="text" name="object.expose.bath_rooms" value="1" />' +
									'</div>' +
								'</div>' +
								'<div class="form-group">' +
									'<label class="control-label col-sm-3">Befeuerung</label>' +
									'<div class="col-sm-2">' +
									'<input class="form-control" type="text" name="object.expose.light" value="Gas" />' +
									'</div>' +
								'</div>' +
								'<div class="form-group">' +
									'<label class="control-label col-sm-3">Heizungsart</label>' +
									'<div class="col-sm-9">' +
										'<input class="form-control" type="text" name="object.expose.firing" value="Zentralheizung" />' +
									'</div>' +
								'</div>' +
							'</fieldset>' +
						'</div>' +
						'</div>' +
					'</form>';

				// basicBox.append($(html));

				basicBox
				.append(
					$(
						new Button(
							{
								on:
								{
									click: () =>
									{
										const company = app.getAuthenticationManager().getCompany();

										if ( company )
										{
											app.getGlobalTabControl().addTab(
												'Neue Besichtigung zu ' + this.m_Data.ObjectNumber,
												new SPA.Survey.SurveyObjectCreator( company, this.m_Data ),
												true, true, false
											);
										}
									},
								},
								size: 'xs',
								title: 'Besichtigung bestellen',
							},
						).getElement(),
					),
				)
				.append(
					$(
						new Button(
							{
								on:
								{
									click: () =>
									{
										const company = app.getAuthenticationManager().getCompany();

										if ( company )
										{
											app.getGlobalTabControl().addTab(
											'Neue Liegenschaftskarte zu ' + this.m_Data.ObjectNumber,
											new SPA.LRM.LandRegionMapCreator( new Wollmilch.Object.CustomerObject( this.m_Data ) ),
											true, true, false,
											);
										}
									},
								},
								size: 'xs',
								title: 'Liegenschaftskarte bestellen',
							},
						).getElement(),
					),
				)
				.append(
					$(
						new Button(
							{
								on:
								{
									click: () =>
									{
										const company = app.getAuthenticationManager().getCompany();

										if ( company )
										{
											app.getGlobalTabControl().addTab(
												app.getMessage( 'BRW.GENERAL.LABEL.tabName' ) + this.m_Data.ObjectNumber,
												new SPA.BRW.New( new Wollmilch.Object.CustomerObject( this.m_Data ) ),
												true, true, false,
											);
										}
									},
								},
								size: 'xs',
								title: app.getSpanMessage( 'BRW.GENERAL.BUTTON.start_BRW' ),
							},
						).getElement(),
					),
				)
				.append(
					$(
						new Button(
							{
								on:
								{
									click: () =>
									{
										const company = app.getAuthenticationManager().getCompany();

										if ( company )
										{
											app.getGlobalTabControl().addTab(
												this.m_Data.ObjectNumber + ' Bewertung',
												new SPA.BWS.New( company, this.m_Data ),
												true, true, false,
											);
										}
									},
								},
								size: 'xs',
								title: app.getSpanMessage( 'BWS.LABEL.start_BWS' ),
							},
						).getElement(),
					),
				)
				.append(
					$(
						new Button(
							{
								on:
								{
									click: () =>
									{
										const company = app.getAuthenticationManager().getCompany();

										if ( company )
										{
											app.getGlobalTabControl().addTab(
												this.m_Data.ObjectNumber + ' Expose',
												new SPA.EXPOSE.New( company, this.m_Data ),
												true, true, false,
											);
										}
									},
								},
								size: 'xs',
								title: app.getSpanMessage( 'EXPOSE.LABEL.start_EXPOSE' ),
							},
						).getElement(),
					),
				)
				.append( flex )
				;

				return this;
			}

			public afterBuild(): void
			{
				if ( !this.m_Navigation ) { return; }

				this.m_Navigation.addRegister( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.OBJECT.register_energy' ), new SPA.Realtor.EnergyCertificateBuilder( this.m_Data ) );
				this.m_Navigation.addRegister( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.OBJECT.register_attachment' ), new SPA.Realtor.AttachmentBuilder( this.m_Data ) );

				/** Chapter2 - moved to TopNavigation */
				// Triggers: Specials, Buildung, Modernization
				if ( this.m_Data.Premise )
				{
					this.m_Navigation.addRegister( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.OBJECT.register_premise' ), new SPA.Realtor.PremiseBuilder( this.m_Data.Premise, this.m_Navigation ) );
				}
			}

			private buildObjectOwnerInfo( owner: Wollmilch.Realtor.ObjectOwner, target: JQuery<HTMLElement> ): void
			{
				ui.$$.h( 4, app.getMessage( 'Aux.BASIC.TRANSLATION.object-owner' ) ).appendTo( target );

				ui.$$.p().text(owner ? app.getMessage( 'Aux.PERSON.SALUTATION.' + owner.Gender ) + " " + owner.Surname + ", " + owner.Name : '' ).appendTo( target );
				this.buildAddressInfo( owner ? owner.Address[ 0 ] as Wollmilch.IPostalAddressObject : null, target, false, false );
			}

			private buildAddressInfo( adr: Wollmilch.IPostalAddressObject|null, target: JQuery<HTMLElement>, map: boolean = true, title: boolean = true ): void
			{
				if ( title ) { ui.$$.h( 4, app.getMessage( 'Address.TYPE.LONG.PostalAddress' ) ).appendTo( target ); }

				ui.$$.address().appendTo( target )
				.append( ui.$$.span().append( adr ? adr.Street + ' ' + adr.HouseNumber : '' ).append( ui.br() ) )
				.append( ui.$$.span().append( adr ? adr.PostalCode + ' ' + adr.City : '').append( ui.br() ) )
				.append(
					ui.$$.span().append(!adr ? '' :
						( adr.State ? adr.State : '' ) +
						( adr.State && adr.Country ? ' ' : '' ) +
						( adr.Country ? "(" + adr.Country + ")" : '' )
					)
				);

				if ( !map ) { return; }

				const mapsDIV = ui.$$.div().appendTo( target );

				mapsDIV.css(
					{
						"width": '100%',
						"height": '400px',
						'background-color': '#555',
						'text-align': 'center',
						'vertical-align': 'middle',
						'font-size': '30px',
						"color": '#777'
					}
				).text( 'LOADING MAP' );

				setTimeout(
					() =>
					{
						// derzeit Geokoordinaten der GSD
						const maps: google.maps.Map = new google.maps.Map(
							mapsDIV[ 0 ],
							{
								fullscreenControl: false,
								keyboardShortcuts: false,
								signInControl: false,
								mapTypeId: google.maps.MapTypeId.HYBRID
							}
						);

						new Promise(
							(resolve, reject) =>
							{
								new google.maps.Geocoder().geocode(
									{ address: adr.display },
									( results, status ) =>
									{
										if ( status == google.maps.GeocoderStatus.OK )
										{
											resolve( results[ 0 ] );
										}
									}
								);
							}
						).then(
							// @ts-ignore
							( result: google.maps.GeocoderResult ) =>
							{
								maps.setZoom( 18 );
								maps.setCenter( result.geometry.location );

								const marker = new google.maps.Marker( { position: result.geometry.location, map: maps } );
								marker.setAnimation( google.maps.Animation.DROP );

								const pa = ui.$$.div().addClass( 'flex-row flex-spacing-around-1' ).css(
									{
										'text-align': 'left'
									}
								);

								this.buildAddressInfo( this.m_Data.Address, ui.$$.div().appendTo( pa ), false );
								this.buildObjectOwnerInfo( this.m_Data.Owner, ui.$$.div().appendTo( pa ) );

								const infowindow = new google.maps.InfoWindow( { content: ui.$$.div().append( pa ).html() } );

								marker.addListener( 'click', () => infowindow.open( maps, marker ) );

								maps.panTo( result.geometry.location );
							}
						);
					},
					1000
				);
			}

		}

	}
}
